import { createQueryKeys } from '@lukemorales/query-key-factory';

export const b2bClients = createQueryKeys('b2bClients', {
  list: (filters: Record<string, string>) => [filters],
  detail: (clientId: string) => [clientId],
  assignees: null,
});
